import { LoadingButton } from "@mui/lab";
import { Box, Button, ButtonGroup, Paper, Typography } from "@mui/material";
import Modal from "@mui/material/Modal";
import React, { useState } from "react";
import { deleteServiceAccount } from "../../apis/service-account/service-account-apis";
import type { ServiceAccount } from "../../domain/service-account";

interface Props {
  account: ServiceAccount;
  onClose: (shouldReload: boolean) => void;
}

export const ServiceAccountsDelete = ({ account, onClose }: Props) => {
  const [loading, setLoading] = useState(false);

  const handleSubmit = () => {
    setLoading(true);

    deleteServiceAccount(account.key)
      .then(() => {
        onClose(true);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Modal open={true}>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="center"
        height="100%"
      >
        <Paper sx={{ width: "50%", padding: "20px" }}>
          <Box height="100%" display="flex" flexDirection="column" gap={3}>
            <Typography variant="h5">
              Do you really want to delete <strong>{account.key}</strong>?
            </Typography>

            <Box textAlign="right">
              <ButtonGroup>
                <Button onClick={() => onClose(false)}>Cancel</Button>
                <LoadingButton
                  variant="contained"
                  color="error"
                  loading={loading}
                  onClick={() => handleSubmit()}
                >
                  Submit
                </LoadingButton>
              </ButtonGroup>
            </Box>
          </Box>
        </Paper>
      </Box>
    </Modal>
  );
};
